var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { DataProcessingJobFactory } from "./DataProcessingJobFactory";
export class DataProcessingJobResult {
  constructor(_data) {
    /**
     */
    __publicField(this, "DataProcessingJob");
    /**
     * Adds support for polymorphism. The discriminator is the schema property
     * name that is used to differentiate between other schema that inherit this
     * schema.
     *
     * @protected
     * @type {string}
     * @memberof DataProcessingJobResult
     */
    __publicField(this, "$type", "V1.DataProcessingJobs.DataProcessingJobResult");
    if (_data) {
      for (const property in _data) {
        if (_data.hasOwnProperty(property)) {
          this[property] = _data[property];
        }
      }
    }
  }
  /**
   * Initializes a new model instance.
   */
  init(_data) {
    if (_data) {
      const $typeDataProcessingJob = _data["DataProcessingJob"] && _data["DataProcessingJob"].$type;
      if ($typeDataProcessingJob) {
        const dataProcessingJob_ = DataProcessingJobFactory.create($typeDataProcessingJob);
        this.DataProcessingJob = dataProcessingJob_.init(_data["DataProcessingJob"]);
      } else {
        this.DataProcessingJob = _data["DataProcessingJob"];
      }
    }
    return this;
  }
  toJSON(_data) {
    _data = typeof _data === "object" ? _data : {};
    _data["DataProcessingJob"] = this.DataProcessingJob ? this.DataProcessingJob.toJSON() : void 0;
    return _data;
  }
}
